
import { GameCategory } from "@/data/games";
import { defineComponent, PropType } from "vue";
import PlayButton from "@/components/PlayButton.vue";
import HighscoreDisplay from "@/components/HighscoreDisplay.vue";

export default defineComponent({
  name: "GameCard",

  components: {
    PlayButton,
    HighscoreDisplay,
  },

  data() {
    return {
      isCollapsed: false,
    };
  },

  props: {
    component: {
      type: String,
    },
    name: {
      type: String,
    },
    description: {
      type: String,
    },
    route: {
      type: String,
      default: "/",
    },
    symbol: {
      type: String,
    },
    categories: {
      type: Array as PropType<GameCategory[]>,
    },
  },

  methods: {
    collapse() {
      this.isCollapsed = !this.isCollapsed;
    },
    getClassByCategory(category: string) {
      switch (category) {
        case "brain":
          return "background--blue color--white";
        case "math":
          return "background--red color--white";
        case "speed":
          return "background--yellow color--black";
        case "memory":
          return "background--orange color--black";
        case "endurance":
          return "background--brown color--white";
      }
    },
    routeToGame() {
      this.$store.commit("transitionName", "home-to-game");
      setTimeout(() => {
        this.$router.push(this.route);
      }, 1100);
    },
  },
});
